function notification(message, state) {
    if (!$(".lora-toast-wrap")[0]) {
        $("body").append($("<div class='lora-toast-wrap'></div>"));
    }
    $(".lora-toast-wrap")
        .append($("<div class='lora-toast-item'></div>")
        .append($("<div class='lora-toast-item-content'></div>")
        .append($("<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'><use xlink:href='#state-" + state + "' /></svg>"))
        .append($("<p/>").html(message))
    ));
    TweenMax.staggerFromTo(".lora-toast-item", 0.5, { yPercent: -100 }, { yPercent: 0, autoAlpha: 1, ease: Back.easeOut }, 0.05, notificationClose);
}

function notificationClose() {
    TweenMax.set(".lora-toast-wrap", { delay: 5, onComplete: function() {
        TweenMax.staggerTo(".lora-toast-item", 0.5, { yPercent: -100, autoAlpha: 0, ease: Back.easeOut, delay: 5 }, 0.05, function() {
            $(".lora-toast-wrap").remove();
        });
    }});
}
